import { createSelector } from "@reduxjs/toolkit";
import selectAuthRaw from "./selectAuthRaw";

export default createSelector(selectAuthRaw, ({ user }) => user);
